<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()

const pdfPath = computed(() => {
  return locale.value === 'tw' ? 'Privacy_Policy_TW' : 'Privacy_Policy'
})

function onResize() {
  if (window.innerWidth > 993) {
    $('.footer-nav-body').removeClass('collapse')
    $('.footer-nav-title').removeAttr('data-toggle').removeAttr('collapse')
  } else {
    $('.footer-nav-body').addClass('collapse')
    $('.footer-nav-title').attr('data-toggle', 'collapse')
  }
}

function onGoTop() {
  $('html, body').animate({ scrollTop: 0 }, 'slow')
}

function footerSub() {
  if (window.innerWidth > 1199) {
    $('.sub-icon').trigger('click')
  } else {
    $('.navbar-toggler').trigger('click')
    $('.sub-icon').trigger('click')
  }
}

onMounted(() => {
  nextTick(() => {
    window.addEventListener('resize', onResize)
    onResize()
  })
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize)
})
</script>

<template>
  <footer>
    <div class="footer">
      <div class="faq-apps-item-container container text-center">
        <div class="service w-100 d-flex py-4">
          <!-- service link -->
          <div id="footer-accordion" class="accordion service-list">
            <div class="service-column">
              <div
                id="headingOne"
                class="footer-nav-title"
                data-target="#collapseOne"
              >
                <p>{{ $t('footer_product_title') }}</p>
                <div class="footer-click">
                  <span></span>
                  <span></span>
                </div>
              </div>
              <div
                id="collapseOne"
                class="footer-nav-body"
                data-parent="#footer-accordion"
              >
                <a
                  class="nav-link"
                  href="https://www.tpisoftware.com/products/digirunner"
                  target="_blank"
                  title="digiRunner"
                >
                  digiRunner
                </a>
                <a
                  class="nav-link"
                  href="https://www.tpisoftware.com/products/digilogs"
                  target="_blank"
                  title="digiLogs"
                >
                  digiLogs
                </a>
                <a
                  class="nav-link"
                  href="https://www.tpisoftware.com/products/digimars"
                  target="_blank"
                  title="digiMars"
                >
                  digiMars
                </a>
                <a
                  class="nav-link"
                  href="https://www.tpisoftware.com/products/systalk-chat"
                  target="_blank"
                  title="SysTalk.Chat"
                >
                  SysTalk.Chat
                </a>
                <a
                  class="nav-link"
                  href="https://www.tpisoftware.com/products/systalk-rpa"
                  target="_blank"
                  title="SysTalk.RPA"
                >
                  SysTalk.RPA
                </a>
              </div>
            </div>
            <div class="service-column">
              <div
                id="headingTwo"
                class="footer-nav-title"
                data-target="#collapseTwo"
              >
                <p>{{ $t('footer_add_title') }}</p>
                <div class="footer-click">
                  <span></span>
                  <span></span>
                </div>
              </div>

              <div
                id="collapseTwo"
                class="footer-nav-body"
                data-parent="#footer-accordion"
              >
                <a
                  class="nav-link"
                  href="https://www.tpisoftware.com/contact-us#taipei"
                  target="_blank"
                  title="台北總部"
                >
                  {{ $t('footer_add_taipei') }}
                </a>
                <a
                  class="nav-link"
                  href="https://www.tpisoftware.com/contact-us#hsinchu"
                  target="_blank"
                  title="台中專案管理中心"
                >
                  {{ $t('footer_add_taichung') }}
                </a>
                <a
                  class="nav-link"
                  href="https://www.tpisoftware.com/contact-us#taichung"
                  target="_blank"
                  title="新竹專案管理中心"
                >
                  {{ $t('footer_add_hsinchu') }}
                </a>
                <a
                  class="nav-link"
                  href="https://www.tpisoftware.com/contact-us#tainan"
                  target="_blank"
                  title="台南開發中心"
                >
                  {{ $t('footer_add_tainan') }}
                </a>
                <a
                  class="nav-link"
                  href="https://www.tpisoftware.com/contact-us#kaohsiung"
                  target="_blank"
                  title="高雄開發中心"
                >
                  {{ $t('footer_add_kaohsiung') }}
                </a>
                <a
                  class="nav-link"
                  href="https://www.tpisoftware.com/contact-us#shanghai"
                  target="_blank"
                  title="上海"
                >
                  {{ $t('footer_add_shanghai') }}
                </a>
                <a
                  class="nav-link"
                  href="https://www.tpisoftware.com/contact-us#singapore"
                  target="_blank"
                  title="新加坡"
                >
                  {{ $t('footer_add_singapore') }}
                </a>
                <a
                  class="nav-link"
                  href="https://www.tpisoftware.com/contact-us#vietnam"
                  target="_blank"
                  title="越南"
                >
                  {{ $t('footer_add_vietnam') }}
                </a>
              </div>
            </div>
            <div class="service-column">
              <div
                id="headingThree"
                class="footer-nav-title"
                data-target="#collapseThree"
              >
                <p>{{ $t('footer_newsletter_title') }}</p>
                <div class="footer-click">
                  <span></span>
                  <span></span>
                </div>
              </div>

              <div
                id="collapseThree"
                class="footer-nav-body"
                data-parent="#footer-accordion"
              >
                <a
                  class="nav-link"
                  href="https://www.tpisoftware.com/media-center#2020"
                  target="_blank"
                  title="2020"
                >
                  2020
                </a>
                <a
                  class="nav-link"
                  href="https://www.tpisoftware.com/media-center#2019"
                  target="_blank"
                  title="2019"
                >
                  2019
                </a>
                <a
                  class="nav-link"
                  href="https://www.tpisoftware.com/media-center#2018"
                  target="_blank"
                  title="2018"
                >
                  2018
                </a>
                <a
                  class="nav-link footer-sub"
                  href="#"
                  title="訂閱電子報"
                  @click.prevent="footerSub"
                >
                  {{ $t('footer_newsletter_subscribe') }}
                </a>
              </div>
            </div>
            <div class="service-column">
              <div
                id="headingFour"
                class="footer-nav-title"
                data-target="#collapseFour"
              >
                <p>{{ $t('footer_resources_title') }}</p>
                <div class="footer-click">
                  <span></span>
                  <span></span>
                </div>
              </div>

              <div
                id="collapseFour"
                class="footer-nav-body"
                data-parent="#footer-accordion"
              >
                <a
                  class="nav-link"
                  href="https://www.tpisoftware.com/tpu/"
                  target="_blank"
                  title="昕力大學"
                >
                  {{ $t('footer_resources_tpu') }}
                </a>
                <a
                  class="nav-link"
                  href="https://www.tpisoftware.com/"
                  target="_blank"
                  title="昕力官網"
                >
                  {{ $t('footer_resources_tpi') }}
                </a>
              </div>
            </div>
          </div>

          <!-- media link -->
          <div class="medla-link">
            <!-- social media -->
            <div class="social-media">
              <p>{{ $t('footer_social_title') }}</p>
              <ul>
                <a href="https://lihi1.com/5GCnS" target="_blank">
                  <li><font-awesome :icon="['fab', 'facebook-f']" /></li>
                </a>
                <a href="https://lihi1.com/xq6vG" target="_blank">
                  <li><font-awesome :icon="['fab', 'linkedin-in']" /></li>
                </a>
                <a href="https://lihi1.com/if1Rj" target="_blank">
                  <li><font-awesome :icon="['fab', 'youtube']" /></li>
                </a>
              </ul>

              <p>
                {{ $t('footer_social_phone') }} :
                <a href="tel:+886-2-8751-1610">+886 2 8751 1610</a>
              </p>
              <p>
                Email :
                <a href="mailto:service@tpisoftware.com">
                  service@tpisoftware.com
                </a>
              </p>
            </div>
          </div>
        </div>

        <!-- go top -->
        <button class="btn gotop" @click="onGoTop">
          <font-awesome :icon="['fas', 'chevron-up']" />
        </button>
      </div>

      <!-- copyright -->
      <div class="copyright">
        <img
          alt="TPIsoftware logo"
          src="~/assets/app/images/copyright-tw.png"
        />
        <div class="privacy font-notosans">
          {{ $t('footer_copyright') }}
          <a target="_blank" :href="`/portal/pdf/${pdfPath}.pdf`">
            {{ $t('footer_copyright_link') }}
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>
